module.exports = __webpack_public_path__ + "static/media/plCreditsDark.2ee15130.png";